import React, { useEffect, useState, useCallback } from "react";
import { motion, useAnimation } from "framer-motion";
import bgImage from "../Assets/Images/section1-bg.jpg";
import astrologyImage from "../Assets/Images/chakar.png";
import { Link} from "react-router-dom";

const HeroSection = () => {
  const [rotation, setRotation] = useState(0);
  const animationControls = useAnimation();
  const textControls = useAnimation();
  const [lastScrollY, setLastScrollY] = useState(0);

  const handleScroll = useCallback(() => {
    const currentScrollY = window.scrollY;
    setRotation(currentScrollY / 5);

    if (currentScrollY > lastScrollY) {
      textControls.start({ opacity: 1, y: 0 });
    } else {
      textControls.start({ opacity: 0.8, y: -30 });
    }
    setLastScrollY(currentScrollY);
  }, [textControls, lastScrollY]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  // Run animations on page load
  useEffect(() => {
    animationControls.start({ opacity: 1, scale: 1, transition: { duration: 1 } });
    textControls.start({ opacity: 1, x: 0, transition: { duration: 1 } });
  }, [animationControls, textControls]);

  return (
    <motion.div
      className="relative text-white flex flex-col-reverse md:flex-row items-center md:items-start px-6 md:px-12 py-10 min-h-screen"
      style={{ backgroundImage: `url(${bgImage})`, backgroundSize: "cover", backgroundPosition: "center" }}
      initial={{ opacity: 0, scale: 0.9 }}
      animate={animationControls}
    >
      {/* Left Content */}
      <motion.div
        className="w-full md:w-[56%] text-left mx-auto mt-[100px]"
        initial={{ opacity: 0, x: -50 }}
        animate={textControls}
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4">
          Welcome to <br /> Shri Radha Krishna Mandir
        </h1>
        <p className="mt-4 text-base sm:text-lg text-gray-300 leading-relaxed max-w-md">
          A sacred place of spiritual enlightenment and astrological wisdom, led by Astrologer Pt. Kamlesh Sharma.
        </p>
        <motion.button
          className="mt-6 px-6 py-3 bg-purple-600 text-white font-semibold rounded-full shadow-lg hover:bg-purple-700"
          whileHover={{ scale: 1.1 }}
        >
         <Link to="/about">Learn More</Link> 
        </motion.button>
      </motion.div>

     {/* Rotating Image */}
<motion.div className="w-full md:w-[40%] flex justify-center items-center relative overflow-hidden">
  <motion.img
    src={astrologyImage}
    alt="Astrology Symbols"
    className="w-[100%] h-auto object-contain"
    style={{ transformOrigin: "center", rotate: `${rotation}deg` }}
    initial={{ opacity: 0, scale: 0.8 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 1, type: "spring", stiffness: 100 }}
  />
</motion.div>

    </motion.div>
  );
};

export default HeroSection;
